var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params && _vm.params.data && _vm.params.data.verbose_status)?_c('v-chip',{staticClass:"mr-1 text-capitalize font-weight-bold",class:_vm.$helper.getOrderStatusColor(_vm.params.data.status, true),attrs:{"x-small":""}},[_vm._v(" "+_vm._s(_vm.params.data.verbose_status)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }